module.exports = __webpack_public_path__ + "static/lee.0954b8a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/lee.jpg
// module id = 131
// module chunks = 35783957827783 248600712657012